export default {
  appliedDiscount: {
    id: 'funnel_discount_card_applied_discount',
    defaultMessage: '⚡ You get a discount (yay) {amount}',
  },
}
